import styled from 'styled-components';

import {Skeleton} from '~/shared/components/Loaders';
import {media} from '~/shared/theme/media';
import {DetailsBox} from '~/shared/components/UserTransactions/components/styled';

import {MobileDetailsBoxWrapper} from './MoneyCardDetail';
import {InnerWrapper, MobileInnerWrapper, MoneyCardDetailWrapper, Title} from './shared.styles';

const MobileTitleLoaderWrapper = styled.div`
  margin-top: 15px;
`;

const FirstTextSkeleton = styled(Skeleton)`
  width: 46px;
  height: 10px;
  margin: auto;
  margin-top: 5px;
  ${media.minDesktop`
    width: 108px;
    height: 24px;
    margin-top: 0;
    margin: auto;
  `}
`;

const SecondTextSkeleton = styled(Skeleton)`
  width: 55px;
  height: 10px;
  margin: auto;
  margin-top: 5px;
  ${media.minDesktop`
    width: 82px;
    height: 16px;
    margin: auto;
    margin-top: 12px;
  `}
`;

export const MobileLoaderComponent = () => {
  return (
    <>
      <MobileTitleLoaderWrapper>
        <Title>
          <Skeleton width={230} height={26} />
        </Title>
      </MobileTitleLoaderWrapper>
      <MobileInnerWrapper>
        <MobileDetailsBoxWrapper>
          <DetailsBox isMobile>
            <FirstTextSkeleton />
            <SecondTextSkeleton />
          </DetailsBox>
        </MobileDetailsBoxWrapper>
        <MobileDetailsBoxWrapper>
          <DetailsBox isMobile>
            <FirstTextSkeleton />
            <SecondTextSkeleton />
          </DetailsBox>
        </MobileDetailsBoxWrapper>
        <MobileDetailsBoxWrapper>
          <DetailsBox isMobile>
            <FirstTextSkeleton />
            <SecondTextSkeleton />
          </DetailsBox>
        </MobileDetailsBoxWrapper>
      </MobileInnerWrapper>
    </>
  );
};

export const DesktopLoaderComponent = () => (
  <>
    <Title>
      <Skeleton width={263} height={26} />
    </Title>
    <MoneyCardDetailWrapper>
      <InnerWrapper>
        <DetailsBox>
          <FirstTextSkeleton />
          <SecondTextSkeleton />
        </DetailsBox>
      </InnerWrapper>

      <InnerWrapper>
        <DetailsBox>
          <FirstTextSkeleton />
          <SecondTextSkeleton />
        </DetailsBox>
      </InnerWrapper>

      <InnerWrapper>
        <DetailsBox>
          <FirstTextSkeleton />
          <SecondTextSkeleton />
        </DetailsBox>
      </InnerWrapper>
    </MoneyCardDetailWrapper>
  </>
);
